import React from 'react';
import {
  HiUserCircle,
  HiMapPin,
  HiCurrencyDollar,
  HiUserGroup,
  HiSparkles,
  HiXMark,
  HiChatBubbleLeftRight,
} from 'react-icons/hi2';
import styles from './CompactProfileCard.module.css';
import avatar from './../../../assets/default-avatar.svg';
import { useAuth } from "./../../../utils/AuthContext/authcontext";
import Button from '../../ui/Button';

function canViewProfile(user, viewer) {
  const setting = user.privacy || 'public';
  if (setting === 'public') return true;
  if (setting === 'private') return viewer?.uid === user.uid;
  if (setting === 'friends') return user.friends?.includes(viewer?.uid);
  return false;
}

export default function CompactProfileCard({ user, onClose, onInvite, isTile = false }) {
   const { user: viewer, userData, claims } = useAuth(); 
   
  if(canViewProfile(user, viewer) == false) {
	return (
		<div className={`${styles.container} ${isTile == true ? styles.cardprofile : ''}`}>
			<Button variant="ghost" className={styles.closeBtn} onClick={onClose}>
			  <HiXMark size={24} />
			</Button>
			 This profile is private.
		</div>
	); 
  }
 
  return (
    <div className={`${styles.container} ${isTile == true ? styles.cardprofile : ''}`}>
        <Button variant="ghost" className={styles.closeBtn} onClick={onClose}>
          <HiXMark size={24} />
        </Button>
      <div className={styles.header}>
		<div className={styles.crest}>
			<img src={user.profilePicture || avatar} alt={`${user.username}`} className={styles.avatar}  onError={(e) => (e.target.src = avatar)} />
			<div className={styles.info}>
			  <h3 className={styles.username}>{user.username}</h3>
			  <span className={styles.subtext}>{user.fullName}</span>
			</div>
		</div>
      {user.affiliationName && (
        <div className={styles.affiliation}>
          <img src={user.affiliationLogoUrl} alt={user.affiliationName} className={styles.affLogo} />
          <span>{user.affiliationName}</span>
        </div>
      )}
      </div>
	  
      <div className={styles.metaRow}>
        <div className={styles.iconpair}><HiUserCircle className={styles.icon} /><span>#{user.reputation || '-'}</span></div>
        <div className={styles.iconpair}><HiUserGroup className={styles.icon} /><span>{user.debatesCount || 0} debates</span></div>
		<div className={styles.iconpair}><HiCurrencyDollar className={styles.icon} /><span>{user.ratioCoin || 0} Ratiocoin</span></div>
      </div>

      <div className={styles.metaRow}>
        {user.location && (
          <>
            <div className={styles.iconpair}><HiMapPin className={styles.icon} /><span>{user.location}</span></div>
          </>
        )}
        {user.experience && (
          <>
            <div className={styles.iconpair}><HiSparkles className={styles.icon} /><span>{user.experience}</span></div>
          </>
        )}
      </div>

      {user.bio && <p className={styles.bio}>{user.bio}</p>}

      {user.topics?.length > 0 && (
        <div className={styles.topics}>
          {user.topics.map((topic, idx) => (
            <span key={idx} className={styles.topicTag}>{topic}</span>
          ))}
        </div>
      )}

      <Button variant="primary" className={styles.inviteBtn} onClick={() => onInvite?.(user)}>
        <HiChatBubbleLeftRight /> Invite to Debate
      </Button>
    </div>
  );
}
